export default function getClassOfPlanContent(type) {
  switch (type) {
    case 'dot':
      return 't-dot'
    case 'check':
      return 't-check'
    case 'none':
    default:
      return null
  }
}
